import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxDropdown, IAxDropdownOptions } from "@axess/limestone";

export interface IAxBirthDateInitData {
    birthdayPattern: string;
    parentId: string;
    outputTarget: string;
    setDay: string;
    setMonth: string;
    setYear: string;
    setBirthDate: string;
}

@ModuleName("AxBirthDateInputTriple")
export class AxBirthDateInputTriple implements AxInit {
    private _birthdayPattern: string = "";

    private _birthDateMonthDropDown: AxDropdown = new AxDropdown();
    private _birthDateDayDropDown: AxDropdown = new AxDropdown();
    private _birthDateYearDropDown: AxDropdown = new AxDropdown();

    private _parentId: string;
    private _outputTarget: string;

    private _month: string;
    private _day: string;
    private _year: string;

    AxInit(initData: IAxBirthDateInitData): void {

        this._parentId = initData.parentId;
        this._birthdayPattern = initData.birthdayPattern;
        this._outputTarget = initData.outputTarget;

        this._birthDateMonthDropDown.init(this._parentId + ' .axBirthDate__month-selection__month-wrapper',
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent, value) => {
                    this._month = value as string;
                    this.getDaysDropDownList();
                    this.setOutPutBirthDate();
                }
            });

        this._birthDateDayDropDown.init(this._parentId + ' .axBirthDate__day-selection__day-wrapper',
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent, value) => {
                    this._day = value as string;
                    this.setOutPutBirthDate();
                }
            });

        this._birthDateYearDropDown.init(this._parentId + ' .axBirthDate__year-selection__year-wrapper',
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent, value) => {
                    this._year = value as string;
                    this.getDaysDropDownList();
                    this.setOutPutBirthDate();
                }
            });

        if (initData.setBirthDate) {
            let momentFamilyMemberDate = moment(initData.setBirthDate, this._birthdayPattern.toUpperCase(), true);

            const monthValue = momentFamilyMemberDate.format("MM");
            const dayValue = momentFamilyMemberDate.format("DD");
            const yearValue = momentFamilyMemberDate.format("YYYY");
            this.setCurrentSavedDate(monthValue, dayValue, yearValue);
        }

        if (initData.setDay && initData.setMonth && initData.setYear) {
            this.setCurrentSavedDate(initData.setMonth, initData.setDay, initData.setYear);
        } else if (!initData.setBirthDate) {
            this._birthDateMonthDropDown.resetSelection();
            this._birthDateDayDropDown.resetSelection();
            this._birthDateYearDropDown.resetSelection();
        }
    }

    getDaysDropDownList() {
        const daysInMonth = moment(`${this._year ?? "2012"}-${this._month}`, "YYYY-MM").daysInMonth();
        $(this._parentId + ' .registerBirthDateMonthList').html("");

        for (let i = 1; i <= daysInMonth; i++) {
            const inner = document.createElement("li");
            inner.innerHTML = i.toString();
            inner.classList.add("ax-dropdown__item");
            inner.setAttribute("data-value", i.toString());

            $(this._parentId + ' .registerBirthDateMonthList').append(inner);
        }

        if (this._day != null && parseInt(this._day) > daysInMonth) {
            this._birthDateDayDropDown.setValue("1");
        }
    }

    // setCurrentSavedDate
    setCurrentSavedDate(month: string, day: string, year: string) {
        this._birthDateMonthDropDown.setValue(month);
        this._birthDateDayDropDown.setValue(day);
        this._birthDateYearDropDown.setValue(year);

        this._month = month;
        this._day = day;
        this._year = year;

        this.setOutPutBirthDate();
    }

    // setCartPersonBirthDate
    setOutPutBirthDate() {
        if (this._month && this._day && this._year) {
            let momentDate = moment(this._month + '-' + this._day + '-' + this._year, 'MM-DD-YYYY');

            let $outputElem = $(this._parentId).find(this._outputTarget);

            if ($outputElem.length > 0) {
                $outputElem.val(momentDate.format(this._birthdayPattern.toUpperCase()));
                $outputElem.trigger('change').trigger('blur');
            }
        }
    }
}